import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Check from "../assets/check.png";
import { updateCouponDetails } from "../redux/sagas/subscription/paymentSaga";
import ApiService from "../services/ApiService";
import "./CardPayment.scss";
import LocalStorage from "../services/LocalStorage";
import { useIsLoading } from "../redux/reducers/SubscriptionReducer";
import { IoLockClosed } from "react-icons/io5";
const useOptions = () => {
  const options = {
    style: {
      base: {
        iconColor: "#bababa",
        color: "#333",
        backgroundColor: "#FFF",
        margin: "16px",
        fontWeight: "400",
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#333",
        },
        "::placeholder": {
          color: "#999",
        },
      },
      invalid: {
        iconColor: "red",
        color: "red",
      },
    },
  };
  return options;
};

const CardPaymentForm = ({ onSuccess, isUpdate = false }) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const dispatch = useDispatch();

  const [cardholder, setCardholder] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponDetails, setCouponDetails] = useState(true);
  const [couponValidated, setCouponValidated] = useState(true);
  const [couponLoading, setCouponLoading] = useState(false);
  const [isLoad, setLoad] = useState(false);
  const isLoading = useIsLoading();

  useEffect(() => {
    return () => {
      setLoad(false);
      dispatch(
        updateCouponDetails({
          coupon: {},
        })
      );
    };
  }, []);

  useEffect(() => {
    if (isLoad && isLoading) {
      setLoad(false);
    }
  }, [isLoading]);

  const handleChange = (e) => {
    setCardholder(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    if (couponCode && !couponValidated) {
      return toast.error(
        "Coupon Entered but not applied. Please clear if not intended"
      );
    }
    setLoad(true);
    const result = await stripe.createToken(
      elements.getElement(CardNumberElement),
      {
        name: cardholder,
      }
    );
    if (result.error) {
      toast.error(result.error.message);
      setLoad(false);
    } else if (result.token) {
      LocalStorage.storeData("loginPopup", true);
      onSuccess({
        token: result.token.id,
        couponCode: couponCode && couponValidated ? couponCode : "",
      });
    }
  };

  const handleRemoveCouponCodeClick = async () => {
    try {
      dispatch(
        updateCouponDetails({
          coupon: "",
        })
      );
      toast.success("Coupon removed successfully!");
      setCouponValidated(false);
    } catch (e) {
      setCouponValidated(true);
      toast.error("Error in removing coupon");
    }
  };

  const handleApplyCouponClick = async () => {
    if (!couponCode.trim()) {
      toast.error("Please enter a coupon code");
      return;
    }
    try {
      setCouponLoading(true);
      const res = await ApiService.checkCouponValidation(couponCode);
      setCouponDetails(res?.data?.coupon);
      if (!res?.data?.coupon?.valid) {
        setCouponValidated(false);
        toast.error("Invalid Coupon");
        setCouponLoading(false);
        return;
      }
      dispatch(
        updateCouponDetails({
          coupon: res?.data?.coupon,
        })
      );
      toast.success(
        `Congratulations you got ${
          res?.data?.coupon?.percent_off
            ? `${res?.data?.coupon?.percent_off}%`
            : `$${res?.data?.coupon?.amount_off / 100}`
        } off!`
      );
      setCouponValidated(true);
      setCouponLoading(false);
    } catch (e) {
      setCouponValidated(false);
      setCouponLoading(false);

      toast.error("Invalid Coupon");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="columns ">
        <div className="column">
          <label className="label ml0">Card Details:</label>
          <div className="input-card">
            <CardNumberElement options={options} />
          </div>
        </div>
      </div>

      <div className="columns">
        <div className="column">
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <label className="label ml0">Expiration date</label>
              <div className="input-card">
                <CardExpiryElement options={options} />
              </div>
            </div>
            <div
              className="ml10"
              style={{ display: "flex", flexDirection: "column", flex: 1 }}
            >
              <label className="label ml0">CVV</label>
              <div className="input-card">
                <CardCvcElement options={options} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="stripe-trust-indicator">
        <IoLockClosed className="stripe-lock-icon" />
        <span className="stripe-trust-text">
          <strong>Secure payment powered by Stripe</strong>
          <br />
          Your card is encrypted and never stored on our servers.
        </span>
      </div>

      <button
        style={{ textAlign: "center" }}
        className="button is-large is-rounded dashBtn btnself"
        type="submit"
        disabled={
          (couponCode && !couponValidated) || !stripe || isLoad || isLoading
        }
      >
        {!isUpdate ? "Start 7-Day Free Trial" : "Update"}
      </button>
      {!isUpdate && (
        <p className="cta-helper-text">
          No charge today &bull; Cancel anytime before day 7 to avoid charges
        </p>
      )}

      {!isUpdate && (
        <div className="coupon-section">
          {couponCode && couponValidated ? (
            <div
              className="coupon-applied"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 15px",
                border: "1px solid #1aad58",
                borderRadius: "5px",
              }}
            >
              <img src={Check} alt="check" style={{ width: "24px" }} />
              <label style={{ fontWeight: 700 }}>
                {couponCode}
                <span
                  style={{
                    fontWeight: 400,
                    color: "#1aad58",
                    marginLeft: "5px",
                  }}
                >
                  applied
                </span>
              </label>
              <a
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  textDecoration: "none",
                  marginLeft: "40px",
                  cursor: "pointer",
                }}
                onClick={handleRemoveCouponCodeClick}
                type="button"
              >
                Remove
              </a>
            </div>
          ) : (
            <div className="coupon-input-row">
              <input
                className="input has-input-background coupon-input"
                type="text"
                name="couponCode"
                placeholder="Coupon Code"
                value={couponCode}
                onChange={(e) => {
                  setCouponValidated(false);
                  setCouponCode(e.target.value);
                }}
              />
              <button
                className="button dashBtn apply-btn-inline"
                onClick={handleApplyCouponClick}
                type="button"
                disabled={couponLoading}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      )}
    </form>
  );
};

export default CardPaymentForm;
